import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_COMBO_LOAI_TAI_SAN } from "actions/LoaiTaiSan/actionTypes";
import {
  getComboLoaiTaiSan as reloadComboLoaiTaiSan,
  getComboLoaiTaiSanSuccess,
  getComboLoaiTaiSanFailure,
  postLoaiTaiSanSuccess,
  postLoaiTaiSanFailure,
} from "actions/LoaiTaiSan";
import LoaiTaiSanApi from "service/loaiTaiSanApi";
import { pushNotification } from "utils/notifications";
import { POST_LOAI_TAI_SAN_TM } from "actions/LoaiTaiSan/actionTypes";
import { getLoaiTaiSanTMCDReloadTMLTS } from "actions/ThemMoiCamDo";
import { showModalLoaiTaiSan } from "actions/LoaiTaiSan";

function* getComboLoaiTaiSan(action) {
  try {
    const response = yield call(LoaiTaiSanApi.combo, action.dataSearch);
    if (response.ok) {
      yield put(getComboLoaiTaiSanSuccess(response.data));
    } else {
      pushNotification(
        "Không tải được loại tài sản",
        "error",
        "TOP_CENTER",
        1000
      );
      yield put(getComboLoaiTaiSanFailure());
    }
  } catch (error) {
    pushNotification(
      "Không tải được loại tài sản",
      "error",
      "TOP_CENTER",
      1000
    );
    yield put(getComboLoaiTaiSanFailure());
  }
}

function* postLoaiTaiSanTM(action) {
  try {
    const response = yield call(LoaiTaiSanApi.themMoi, action.dataPost);
    if (response.ok) {
      if (response.data.Error) {
        yield put(postLoaiTaiSanFailure(response.data));
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
      } else {
        yield put(postLoaiTaiSanSuccess(response.data));
        pushNotification(
          "Thêm mới loại tài sản thành công",
          "success",
          "TOP_CENTER",
          2000
        );
        yield put(
          getLoaiTaiSanTMCDReloadTMLTS({
            loaiTaiSan: "",
            notloadThuocTinh: false,
          })
        );
        yield put(reloadComboLoaiTaiSan({ trangThai: "" }));
        yield put(showModalLoaiTaiSan(false));
      }
    } else {
      yield put(postLoaiTaiSanFailure());
    }
  } catch (error) {
    yield put(postLoaiTaiSanFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_COMBO_LOAI_TAI_SAN, getComboLoaiTaiSan);
  yield takeLatest(POST_LOAI_TAI_SAN_TM, postLoaiTaiSanTM);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
